<template>
  <d-container fluid class="main-content-container px-4">
    <welcome />
  </d-container>
</template>

<script>
import Welcome from './Welcome';

export default {
  name: 'home',
  components: {
    'welcome': Welcome
  }
}
</script>
